import React from 'react';
import styled from 'styled-components';
import { bool, func, string } from 'prop-types';

import withColor from 'util/hoc/with-color';
import Carrot from 'library/icons/caret.svg';
import KeyCodes from 'library/helpers/key-codes';
import { NoStyleButton } from 'library/components/button';

const StyledCarrotToggle = withColor(
  styled(NoStyleButton)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 1em 2em;

    > * {
      transition: all 0.25s ease-in-out;
      ${(props) => props.active && `transform: rotate(-180deg);`}
      ${(props) =>
        props.direction == 'right'
          ? `transform: rotate(${props.active ? '90' : '-90'}deg);`
          : ''}
    }
  `
);

const CarrotToggle = ({ active, onClick, direction, ...props }) => {
  return (
    onClick ?
    <StyledCarrotToggle
      {...props}
      type="button"
      className={props.className}
      direction={direction}
      active={active}
      onClick={onClick}
    >
      <Carrot />
    </StyledCarrotToggle>
    :
    <StyledCarrotToggle as="div"
      {...props}
      className={props.className}
      direction={direction}
      active={active}
    >
      <Carrot />
    </StyledCarrotToggle>
  );
};

CarrotToggle.propTypes = {
  active: bool,
  className: string,
  onClick: func,
  direction: string,
};

export default CarrotToggle;
